import type { WordDocumentTemplateFieldsFragment } from '~/api/graphql';
import {
  visibilityInputFromValue,
  visibilityValueFromFragment
} from '~/components/visibility/visibility-selector.utils';

import type { WordTemplateFormState } from './word-template-sections';

/** Form state for creating a new template prefilled from an existing one. */
export function duplicateWordTemplateFormState(template: WordDocumentTemplateFieldsFragment): {
  form: WordTemplateFormState;
  sectioned: boolean;
} {
  const baseTitle = template.title?.trim() ?? '';
  const visibility = visibilityValueFromFragment(template.visibility);
  return {
    // Sectioned mode shows the reused .docx per section (existingFile row).
    sectioned: true,
    form: {
      title: baseTitle ? `Copy of ${baseTitle}` : 'Copy',
      description: template.description || '',
      fillGuidance: template.fillGuidance ?? '',
      visibility: visibilityInputFromValue(visibility),
      sections: template.sections.map((section) => ({
        title: section.title,
        setupGuidance: section.setupGuidance ?? null,
        static: section.static,
        repeatable: section.repeatable,
        required: section.required,
        uploadTemplate: null,
        templateFileId: section.templateFile.id,
        existingFile: {
          id: section.templateFile.id,
          name: section.templateFile.name,
          url: section.templateFile.url ?? null
        }
      }))
    }
  };
}
